
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getTradinglist } from '@/api/user.js'
import Scroll from '@/components/scroller'
export default {
name: 'sign',
components: {
Tab,
TabItem,
Group,
Cell,
Scroll
},
data () {
return {
tabOne: true,
intergralList: [],
changelist: [],
page:1,
rows:20,
notFirstLoad: false,
loadMoreDom: null,
index:1
}
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
},
created () {
this.getTrading('','',1)
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
onItemClick (index) {
this.index = index+1
this.intergralList = []
this.page = 1
this.getTrading('','',index+1)
refresh ('',this.index)
if (index) {
this.tabOne = true
} else {
this.tabOne = false
}
},
getTrading (type, done,incometype) {
/* 得到交易明细列表 */
getTradinglist({
userid: this.userid,
accountid:this.accountid,
incometype: incometype,
owner_type: this.owner_type,
page: this.page,
rows: this.rows
}).then(res => {
if (type === 'refresh' || type === 'search') {
this.intergralList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.intergralList.push({
createdate: item.createdate,
credit: item.credit,
rulename: item.rulename,
incometype: item.incometype
})
})
}
if (res.returnValue.count === 0) {
this.notFirstLoad = true
} else {
this.notFirstLoad = false
}
if (
res.returnValue.list.length === 0 ||
res.returnValue.count < this.rows
) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
},

refresh (done,index) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getTrading('refresh', done,this.index)
},

loadMore (done,index) {
this.page++
this.getTrading('more', done,this.index)
}
}
}
